// import React from "react";
import "./EventOneExp.scss";

const Experience = () => {
  return (
    <div className="experience">
      <div className="container">
        <div className="experience_inner">
          <div className="section_header">
            <div className="left">
              <div className="icon-main">
                <div className="icon">
                  <img
                    src="./assets/img/ecommerce/ecomTwo/icons/destination.png"
                    alt=""
                    className="icon"
                  />
                </div>
              </div>
              <div>
                <h2 className="title">FIND NEW EXPERIENCES</h2>
                <h6 className="sub_title">Explore. Discover. Make a Plan</h6>
              </div>
            </div>
            <div className="right"></div>
          </div>
          <div className="experience-images">
            <div className="image-item1">
              <h2>cricket</h2>
            </div>
            <div className="image-item2">
              <h2>football</h2>
            </div>
            <div className="image-item3">
              <h2>volleyball</h2>
            </div>
            <div className="image-item4">
              <h2>tennis</h2>
            </div>
            <div className="image-item5">
              <h2>ice skating</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
